// Register component(s) with react habitat
// Name of component and webpackChunkName should be uniq

export default {
  PostTypesArchive: () =>
    import(
      /* webpackChunkName: "post-types-archive" */
      './index'
    ),
}
